export enum SupplierClassification {
    BonusPlus = 'BONUS_PLUS',
    Bonus = 'BONUS',
    Contract = 'CONTRACT',
}
